import Project from "../main.js";
import {News} from "../components/news.js";

export class Contact {
	constructor() {
		this.project = new Project()

		this.instances = {
			news: new News()
		}
	}
}